import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=6bb776e4&"
import script from "./addMenu.vue?vue&type=script&lang=js&"
export * from "./addMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports